import React,
{
    useEffect,
    useRef,
    useState
}
from "react";

import
{
    TransformWrapper,
    TransformComponent
}
from "react-zoom-pan-pinch";

import useFloorPlan
    from "../hooks/useFloorPlan";

export default function FloorSpacePlan(
{
    floorId,
    colourMode,
    selectedSpaceId,
    setSelectedSpaceId,
	selectedSpaceTypeId,
	setSelectedSpaceTypeId,
    onSpaceClick
})
{
    const {
        floorPlan,
        loading
    } =
    useFloorPlan(
        floorId
    );
	
	const [flashOn, setFlashOn] =
	    useState(false);
	
	const [width, setWidth] =
	    useState(0);

	const [height, setHeight] =
	    useState(0);

    const containerRef =
        useRef(null);

    const svgRef =
        useRef(null);

    const transformRef =
        useRef(null);

    const [hoverSpace, setHoverSpace] =
        useState(null);

    const clickRef =
        useRef(
        {
            startX: 0,
            startY: 0,
            startTime: 0
        });

    function getFill(space)
    {
        if(colourMode === "organisation")
        {
            return (
                space.organisationColor ||
                "#cccccc"
            );
        }

        return (
            space.spaceTypeColor ||
            "#cccccc"
        );
    }
	
	
	useEffect(
	    function()
	    {
	        if(!selectedSpaceId)
	        {
	            setFlashOn(false);
	            return;
	        }

	        let flashCount =
	            0;

	        setFlashOn(true);

	        const interval =
	            setInterval(
	                function()
	                {
	                    flashCount++;

	                    setFlashOn(
	                        function(prev)
	                        {
	                            return !prev;
	                        }
	                    );

	                    if(flashCount >= 10)
	                    {
	                        clearInterval(
	                            interval
	                        );

	                        setFlashOn(
	                            true
	                        );
	                    }
	                },
	                300
	            );

	        return function()
	        {
	            clearInterval(
	                interval
	            );
	        };
	    },
	    [
	        selectedSpaceId
	    ]
	);
		
	
	useEffect(
	    function()
	    {
	        if(!floorPlan)
	        {
	            return;
	        }

	        const parsedWidth =
	            Number(
	                floorPlan.floorplanImageWidthPx
	            );

	        const parsedHeight =
	            Number(
	                floorPlan.floorplanImageHeightPx
	            );

	        if(
	            !parsedWidth ||
	            !parsedHeight
	        )
	        {
	            return;
	        }

	        setWidth(parsedWidth);
	        setHeight(parsedHeight);
	    },
	    [
	        floorPlan
	    ]
	);

	useEffect(
	    function()
	    {
	        if(
	            !floorPlan ||
	            !containerRef.current ||
	            !transformRef.current ||
	            !width ||
	            !height
	        )
	        {
	            return;
	        }

	        const timer =
	            setTimeout(
	                function()
	                {
	                    const container =
	                        containerRef.current;

	                    if(
	                        !container ||
	                        !transformRef.current
	                    )
	                    {
	                        return;
	                    }

	                    const cw =
	                        container.clientWidth;

	                    const ch =
	                        container.clientHeight;

	                    if(
	                        !cw ||
	                        !ch
	                    )
	                    {
	                        return;
	                    }

	                    const scale =
	                        Math.min(
	                            cw / width,
	                            ch / height
	                        ) * 0.95;

	                    const x =
	                        (
	                            cw -
	                            (
	                                width *
	                                scale
	                            )
	                        ) / 2;

	                    const y =
	                        (
	                            ch -
	                            (
	                                height *
	                                scale
	                            )
	                        ) / 2;
							
							
	                    transformRef.current.setTransform(
	                        x,
	                        y,
	                        scale,
	                        200
	                    );
	                },
	                100
	            );

	        return function()
	        {
	            clearTimeout(
	                timer
	            );
	        };
	    },
	    [
	        floorPlan,
	        width,
	        height
	    ]
	);

    if(
        loading ||
        !floorPlan
    )
    {
        return (
            <div
                style={{
                    padding: "20px"
                }}
            >
                Loading floor...
            </div>
        );
    }

  

    return (
        <div
            ref={containerRef}
            style={{
                width: "100%",
                height: "100%",
                position: "relative",
                overflow: "hidden"
            }}
        >
            <TransformWrapper
			   
                ref={transformRef}
                minScale={0.02}
                maxScale={5}
                wheel={{
                    step: 0.05
                }}
                doubleClick={{
                    disabled: true
                }}
            >
                <TransformComponent
                    wrapperStyle={{
                        width: "100%",
                        height: "100%"
                    }}
                    contentStyle={{
                        width: width,
                        height: height
                    }}
                >
                    <svg
                        ref={svgRef}
                        width={width}
                        height={height}
                        style={{
                            display: "block"
                        }}
                    >
					{
					    floorPlan.floorplanImagePath &&
					    (
					        <image
					            href={
					                "/resolutionsoftwareplatform/" +
					                "dashboard/utilisation/floorplan/image" +
					                "?floorId=" +
					                floorId
					            }

					            xlinkHref={
					                "/resolutionsoftwareplatform/" +
					                "dashboard/utilisation/floorplan/image" +
					                "?floorId=" +
					                floorId
					            }

					            width={width}
					            height={height}

					            preserveAspectRatio="none"
					        />
					    )
					}

						{
						    floorPlan.spaces.map(
						        function(space)
						        {
						            let fillOpacity =
						                0.8;

						            let stroke =
						                "#444444";

						            let strokeWidth =
						                0;
										
										if(selectedSpaceId)
										{
										    if(space.spaceId === selectedSpaceId)
										    {
										        fillOpacity =
										            flashOn
										                ? 1
										                : 0.35;

										        stroke =
										            "#444444";

										        strokeWidth =
										            0;
										    }
										    else
										    {
										        fillOpacity =
										            0.15;
										    }
										}
						            else if(selectedSpaceTypeId)
						            {
						                if(
						                    space.spaceTypeId ===
						                    selectedSpaceTypeId
						                )
						                {
						                    fillOpacity =
						                        1;

						                    stroke =
						                        "#0078ff";

						                    strokeWidth =
						                        0;
						                }
						                else
						                {
						                    fillOpacity =
						                        0.15;
						                }
						            }

						            return (
						                <path
						                    key={
						                        space.spaceId
						                    }
						                    d={
						                        space.svg
						                    }
						                    fill={
						                        getFill(
						                            space
						                        )
						                    }
						                    fillOpacity={
						                        fillOpacity
						                    }
						                    stroke={
						                        stroke
						                    }
						                    strokeWidth={
						                        strokeWidth
						                    }
						                    style={{
						                        cursor:
						                            "pointer"
						                    }}
						                    onMouseDown={
						                        function(e)
						                        {
						                            clickRef.current.startX =
						                                e.clientX;

						                            clickRef.current.startY =
						                                e.clientY;

						                            clickRef.current.startTime =
						                                Date.now();
						                        }
						                    }
						                    onMouseUp={
						                        function(e)
						                        {
						                            const dx =
						                                e.clientX -
						                                clickRef.current.startX;

						                            const dy =
						                                e.clientY -
						                                clickRef.current.startY;

						                            const dist =
						                                Math.sqrt(
						                                    dx * dx +
						                                    dy * dy
						                                );

						                            const duration =
						                                Date.now() -
						                                clickRef.current.startTime;

						                            if(
						                                dist < 5 &&
						                                duration < 250
						                            )
						                            {
						                                
						                            }
						                        }
						                    }
						                    onMouseEnter={
						                        function(e)
						                        {
						                            setHoverSpace(
						                            {
						                                x:
						                                    e.clientX,

						                                y:
						                                    e.clientY,

						                                code:
						                                    space.spaceCode,

						                                name:
						                                    space.spaceName,

						                                capacity:
						                                    space.capacity,

						                                area:
						                                    space.area,

						                                spaceType:
						                                    space.spaceTypeName,

						                                organisation:
						                                    space.organisationName
						                            });
						                        }
						                    }
						                    onMouseMove={
						                        function(e)
						                        {
						                            setHoverSpace(
						                                function(prev)
						                                {
						                                    if(!prev)
						                                    {
						                                        return null;
						                                    }

						                                    return {
						                                        ...prev,
						                                        x: e.clientX,
						                                        y: e.clientY
						                                    };
						                                }
						                            );
						                        }
						                    }
						                    onMouseLeave={
						                        function()
						                        {
						                            setHoverSpace(
						                                null
						                            );
						                        }
						                    }
						                />
						            );
						        }
						    )
						}
                    </svg>
                </TransformComponent>
            </TransformWrapper>

            {
                hoverSpace &&
                (
                    <div
                        style={{
                            position: "fixed",
                            left:
                                hoverSpace.x + 15,
                            top:
                                hoverSpace.y - 20,
                            background:
                                "rgba(15,23,42,0.96)",
                            color:
                                "#ffffff",
                            padding:
                                "12px 14px",
                            borderRadius:
                                "12px",
                            fontSize:
                                "13px",
                            pointerEvents:
                                "none",
                            zIndex:
                                99999,
                            minWidth:
                                "240px"
                        }}
                    >
                        <div
                            style={{
                                fontWeight: 700,
                                marginBottom: "6px"
                            }}
                        >
                            {
                                hoverSpace.code
                            }
                        </div>

                        <div>
                            {
                                hoverSpace.name
                            }
                        </div>

                        <div>
                            Space Type:
                            {" "}
                            {
                                hoverSpace.spaceType
                            }
                        </div>

                        <div>
                            Organisation:
                            {" "}
                            {
                                hoverSpace.organisation
                            }
                        </div>

                        <div>
                            Capacity:
                            {" "}
                            {
                                hoverSpace.capacity
                            }
                        </div>

                        <div>
                            Area:
                            {" "}
                            {
                                hoverSpace.area
                            }
                        </div>
                    </div>
                )
            }
        </div>
    );
}